import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useCustomerAuth } from '../contexts/CustomerAuthContext';

export default function BookingSuccessPage() {
  const [searchParams] = useSearchParams();
  const { customer } = useCustomerAuth();
  const sessionId = searchParams.get('session_id');

  return (
    <div className="min-h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full text-center">
        {/* Checkmark icon */}
        <div
          className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6"
          style={{ backgroundColor: '#dcfce7' }}
        >
          <svg className="w-10 h-10" fill="none" stroke="#16a34a" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
          </svg>
        </div>

        <h1 className="text-3xl font-bold mb-3" style={{ color: 'var(--color-primary)' }}>
          Your Booking is Confirmed!
        </h1>

        <p className="text-lg mb-2" style={{ color: 'var(--color-text)' }}>
          Thank you for booking with Skaha Sauna Co.
        </p>

        <p className="mb-8" style={{ color: 'var(--color-text-light)' }}>
          {customer
            ? 'We\'ve sent a confirmation to your email. You can view your booking details below.'
            : 'A confirmation email will be sent to you shortly with all the details.'}
        </p>

        {sessionId && (
          <p className="text-xs mb-6 break-all" style={{ color: 'var(--color-text-light)' }}>
            Reference: {sessionId}
          </p>
        )}

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          {customer && (
            <Link
              to="/my-bookings"
              className="inline-block px-6 py-3 rounded-xl text-white font-semibold transition-opacity hover:opacity-90"
              style={{ backgroundColor: 'var(--color-accent)' }}
            >
              View My Bookings
            </Link>
          )}
          <Link
            to="/"
            className="inline-block px-6 py-3 rounded-xl font-semibold border-2 transition-colors"
            style={{
              borderColor: 'var(--color-primary)',
              color: 'var(--color-primary)',
            }}
          >
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}
